import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface LoadingStateProps {
  title?: string;
  description?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingState({
  title = "Loading...",
  description,
  className,
  size = "md"
}: LoadingStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12", className)} data-testid="loading-state">
      <Spinner size={size} className="mb-4" />
      <h3 className="text-lg font-semibold text-foreground mb-2" data-testid="loading-title">
        {title}
      </h3>
      {description && (
        <p className="text-muted-foreground text-center max-w-sm" data-testid="loading-description">
          {description}
        </p>
      )}
    </div>
  );
}
